
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppLayout, AdminLayout } from './components/layouts';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { ApplicationForm, RegisterCommunity } from './components/Forms';
import Applications from './pages/Admin/Applications';
import {CheckApplications, SpectApplications, WelcomeScreen } from './pages/Admin/index';
import Communities from './pages/Admin/Communities';
import Invoices from './pages/Admin/Invoices';
import PrivateRoute from './routes/PrivateRoute';
import { ToastProvider } from './contexts/ToastContext';
import ToastNotification from './utils/ToastNotification'
import SoftLoginModal from "./components/Modals/SoftLoginModal";
import { LoadingProvider } from "./contexts/LoadingContext";
import GlobalSpinner from "./utils/GlobalSpinner";

const changeFavicon = (faviconPath) => {
  const link = document.querySelector("link[rel~='icon']");
  if (link) {
      link.href = faviconPath;
  } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = faviconPath;
      document.head.appendChild(newLink);
  }
};


const RouteTitleAndFavicon = () => {
  const location = useLocation();

  useEffect(() => {
      const routeSettings = {
          "/login": { favicon: "/favicon.ico", title: "Permit Demo" },
          "/admin": { favicon: "/favicon.ico", title: "Permit Demo" },
          "/": { favicon: "/favicon.ico", title: "Permit Demo" },
      };

      const defaultSettings = { favicon: "/favicon.ico", title: "Permit Demo" };

      // Get the appropriate settings based on the route
      const settings = Object.keys(routeSettings).find((route) => location.pathname.startsWith(route)) 
          ? routeSettings[Object.keys(routeSettings).find((route) => location.pathname.startsWith(route))]
          : defaultSettings;

      document.title = settings.title;
      changeFavicon(settings.favicon);
  }, [location]);

  return null;
};

function App() {
  const [showSoftLogin, setShowSoftLogin] = useState(false);

  return (
    <Router>
       <LoadingProvider>
       <ToastProvider>
      <AuthProvider>
        <ToastNotification />
        <RouteTitleAndFavicon />
        {showSoftLogin && (
          <SoftLoginModal onClose={() => setShowSoftLogin(false)} />
        )}
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/application" element={<ApplicationForm />} />
            <Route path="/register" element={<RegisterCommunity />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Route>
          <Route path="/login" element={<Login />} />

          <Route element={<PrivateRoute requiredRole="admin" />}> 
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<WelcomeScreen />} />
              <Route path="applications" element={<Applications />} />
              <Route path="applications/:id" element={<Applications />} /> 
              <Route path="communities" element={<Communities />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="simplecheck/application" element={<CheckApplications />} />
              <Route path="simplespect/application" element={<SpectApplications />} />
            </Route>
          </Route>
          <Route element={<PrivateRoute requiredRole="user" />}>
            <Route path="/community/applications" element={<Applications />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
      </ToastProvider>
      <GlobalSpinner />
       </LoadingProvider>
    </Router>
  );
}

export default App;
